import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CTASection = () => {
  return (
    <section className="bg-gradient-to-r from-primary to-brandDark py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white space-y-8">
          <div className="space-y-4">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black">
              Dapatkan Hujung Minggu Anda Semula
            </h2>
            <p className="text-lg md:text-xl font-body opacity-95 max-w-2xl mx-auto">
              Jangan biarkan timbunan kain mengganggu masa berkualiti anda. Biar kami uruskan
              kekemasan almari anda.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              href="/agent-directory"
              className="w-full sm:w-auto px-8 py-4 bg-accent text-secondary rounded-lg font-cta font-bold hover:bg-white transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-2 shadow-lg"
            >
              <Icon name="ShoppingCartIcon" size={20} variant="outline" />
              <span>Tempah Bakul Pertama</span>
            </Link>

            <Link
              href="/contact-page"
              className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-accent text-accent rounded-lg font-cta font-bold hover:bg-accent hover:text-secondary transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-2"
            >
              <Icon name="PhoneIcon" size={20} variant="outline" />
              <span>Hubungi Kami</span>
            </Link>
          </div>

          <div className="pt-4" />
        </div>
      </div>
    </section>
  );
};

export default CTASection;
